import styled from 'styled-components'

export const Wrapper = styled.div`
  border-top: 1px solid #b7b8c1;
  padding-top: 24px;
  display: flex;
  flex-flow: row wrap;
`

export const Parameter = styled.div`
  margin: 0 24px 12px 1px;
  font-size: 16px;
  line-height: 20px;
`

export const Value = styled.div`
  color: #121432;
  white-space: nowrap;
  font-weight: 400;
`

export const Label = styled.div`
  color: #717284;
  font-weight: 600;
`
